(function () {
  if (customElements.get('zoorian-bundle')) return;

  const ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const SOURCE = 'zoorian-bundle';

  const GESCHENK_EIGENSCHAFT = '_zoorian_geschenk';

  const GELD_PLATZHALTER = /\{\{\s*(\w+)\s*\}\}/;

  const RABATT_PLATZHALTER = /\[(prozent|rabatt)\]/;

  const SUCH_VERZOEGERUNG = 250;

  const TREFFER_ANZAHL = 10;

  const START_KARTEN = 2;

  const SUCH_FELDER = 'title,vendor,product_type,variants.title,tag';

  const BILD_KARTE = 400;

  const BILD_TREFFER = 200;

  const FOKUS_ZIELE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function sucheRoute() {
    const route = (window.routes && window.routes.predictive_search_url) || `${ROOT_URL}search/suggest`;

    return String(route).replace(/\/+$/, '');
  }

  function findeAusgelagert(wurzel, kennzeichen, klasse) {
    const drin = wurzel.querySelector(kennzeichen);

    if (drin) return drin;

    if (!wurzel.dataset.sectionId) return null;

    return document.querySelector(`${klasse}${kennzeichen}`);
  }

  function setzeVersteckt(element, zustand) {
    if (!element) return;

    if (zustand) element.setAttribute('hidden', '');
    else element.removeAttribute('hidden');
  }

  function bildGroesse(quelle, breite) {
    const adresse = String(quelle || '');

    if (!adresse || adresse.indexOf('width=') !== -1) return adresse;

    return `${adresse}${adresse.indexOf('?') === -1 ? '?' : '&'}width=${breite}`;
  }

  function loeseSperre() {
    if (document.querySelector('.zbu-picker--offen')) return;

    document.body.classList.remove('zbu-picker-offen');
  }

  function fokussierbare(wurzel) {
    return Array.from(wurzel.querySelectorAll(FOKUS_ZIELE)).filter(
      (element) => element.offsetParent !== null || element === document.activeElement
    );
  }

  function trenneTausender(ziffern, trenner) {
    return ziffern.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${trenner}`);
  }

  function formatiereGeld(cent, format) {
    const vorlage = String(format || '{{amount}}');
    const treffer = vorlage.match(GELD_PLATZHALTER);
    const platzhalter = treffer ? treffer[1] : 'amount';

    let nachkomma = platzhalter.indexOf('no_decimals') === -1 ? 2 : 0;
    let tausender = ',';
    let komma = '.';

    if (platzhalter.indexOf('comma_separator') !== -1) {
      tausender = '.';
      komma = ',';
    } else if (platzhalter.indexOf('apostrophe_separator') !== -1) {
      tausender = "'";
      komma = '.';
    } else if (platzhalter.indexOf('space_separator') !== -1) {
      tausender = ' ';
      komma = ',';
    }

    const zahl = Number(cent) || 0;
    const teile = (Math.abs(zahl) / 100).toFixed(nachkomma).split('.');

    let text = trenneTausender(teile[0], tausender);

    if (teile[1]) text += komma + teile[1];
    if (zahl < 0) text = `-${text}`;

    return vorlage.replace(GELD_PLATZHALTER, text);
  }

  function setzeText(vorlage, werte) {
    return Object.keys(werte).reduce(
      (text, schluessel) => text.split(`[${schluessel}]`).join(werte[schluessel]),
      String(vorlage || '')
    );
  }

  function zuCent(wert) {
    const roh = String(wert == null ? '' : wert).replace(/[^\d.,-]/g, '');
    const letzter = Math.max(roh.lastIndexOf('.'), roh.lastIndexOf(','));
    const trenner = letzter !== -1 && roh.length - letzter - 1 <= 2 ? letzter : -1;

    const ganz = (trenner === -1 ? roh : roh.slice(0, trenner)).replace(/[.,]/g, '');
    const bruch = trenner === -1 ? '' : roh.slice(trenner + 1);

    const zahl = parseFloat(`${ganz || '0'}.${bruch || '0'}`);

    return Number.isFinite(zahl) ? Math.round(zahl * 100) : 0;
  }

  function normalisiere(text) {
    return String(text || '').toLowerCase();
  }

  function nurLieferbar(varianten) {
    return (varianten || []).filter((variante) => variante && variante.verfuegbar);
  }

  function baueEinheit(variante, geldFormat) {
    const mass = variante && variante.unit_price_measurement;

    if (!mass || !variante.unit_price) return '';

    const bezug = Number(mass.reference_value) || 1;
    const menge = bezug === 1 ? '' : `${bezug} `;

    return `${formatiereGeld(variante.unit_price, geldFormat)}/${menge}${mass.reference_unit || ''}`;
  }

  class ZoorianBundle extends HTMLElement {
    connectedCallback() {
      this.config = this.leseConfig();

      if (!this.config) return;

      this.geldFormat = this.config.geldFormat || '{{amount_with_comma_separator}} €';
      this.texte = this.config.texte || {};

      this.stufen = (this.config.stufen || [])
        .map((stufe) => Object.assign({}, stufe, { schwelle: Number(stufe.schwelle) || 0 }))
        .filter((stufe) => stufe.schwelle > 0)
        .sort((a, b) => a.schwelle - b.schwelle);

      const hoechste = this.stufen.length ? this.stufen[this.stufen.length - 1].schwelle : 0;

      this.maxProdukte = Math.max(Number(this.config.maxProdukte) || 0, hoechste, 1);

      this.kategorien = this.config.kategorien || [];

      this.produktCache = new Map();
      this.fuelleCacheAusPool();

      this.auswahl = [];
      this.offenerPlatz = -1;
      this.wahlMarke = 0;
      this.aktiveKategorie = this.kategorien.length ? this.kategorien[0].id : '';

      this.geschenkSchwelle = Number(this.config.geschenkSchwelle) || 0;
      this.geschenkWahl = null;
      this.geschenkOffen = false;

      this.sammleElemente();
      this.verdrahte();
      this.portalierePicker();

      this.zeichne();
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      window.removeEventListener('resize', this.onResize);
      window.clearTimeout(this.pickerTimer);
      window.clearTimeout(this.geschenkTimer);

      this.geschenkOffen = false;

      [this.picker, this.geschenkModal].forEach((element) => {
        if (!element) return;

        element.classList.remove('zbu-picker--offen');
        setzeVersteckt(element, true);

        if (element.parentNode === document.body) this.appendChild(element);
      });

      loeseSperre();
    }

    portalierePicker() {
      [this.picker, this.geschenkModal].forEach((element) => {
        if (!element || element.parentNode === document.body) return;

        document.body.appendChild(element);
      });
    }

    leseConfig() {
      const script = this.querySelector('[data-zbu-config]');

      if (!script) return null;

      try {
        return JSON.parse(script.textContent);
      } catch (fehler) {
        console.error('[zoorian-bundle] Konfiguration nicht lesbar', fehler);
        return null;
      }
    }

    fuelleCacheAusPool() {
      this.kategorien.forEach((kategorie) => {
        kategorie.produkte = (kategorie.produkte || [])
          .map((produkt) => Object.assign({}, produkt, { varianten: nurLieferbar(produkt.varianten) }))
          .filter((produkt) => produkt.varianten.length > 0);

        kategorie.produkte.forEach((produkt) => {
          if (!this.produktCache.has(produkt.handle)) this.produktCache.set(produkt.handle, produkt);
        });
      });
    }

    sammleElemente() {
      this.stufenKacheln = Array.from(this.querySelectorAll('[data-zbu-stufe]'));

      this.slotsWrap = this.querySelector('[data-zbu-slots-wrap]');
      this.slotsTrack = this.querySelector('[data-zbu-slots]');
      this.slotVorlage = this.querySelector('[data-zbu-slot-template]');
      this.trefferVorlage = this.querySelector('[data-zbu-result-template]');
      this.dotsLeiste = this.querySelector('[data-zbu-dots]');

      this.balken = this.querySelector('[data-zbu-fill]');
      this.meldung = this.querySelector('[data-zbu-message]');

      this.checkout = this.querySelector('[data-zbu-checkout]');
      this.leerenKnopf = this.querySelector('[data-zbu-clear]');
      this.liste = this.querySelector('[data-zbu-lines]');
      this.leerText = this.querySelector('[data-zbu-empty]');

      this.zwischenZeile = this.querySelector('[data-zbu-subtotal-row]');
      this.zwischenFeld = this.querySelector('[data-zbu-subtotal]');
      this.rabattZeile = this.querySelector('[data-zbu-discount-row]');
      this.rabattLabel = this.querySelector('[data-zbu-discount-label]');
      this.rabattFeld = this.querySelector('[data-zbu-discount]');
      this.summeFeld = this.querySelector('[data-zbu-total]');

      this.sparFeld = this.querySelector('[data-zbu-save]');
      this.fehlerFeld = this.querySelector('[data-zbu-error]');
      this.submit = this.querySelector('[data-zbu-submit]');
      this.submitText = this.querySelector('[data-zbu-submit-text]');

      this.picker = this.findePicker();

      const feld = this.picker || this;

      this.pickerTitel = feld.querySelector('[data-zbu-picker-title]');
      this.suchfeld = feld.querySelector('[data-zbu-search]');
      this.trefferListe = feld.querySelector('[data-zbu-results]');
      this.pickerHinweis = feld.querySelector('[data-zbu-picker-hint]');
      this.tabsLeiste = feld.querySelector('[data-zbu-tabs]');
      this.kategorieTabs = Array.from(feld.querySelectorAll('[data-zbu-tab]'));
      this.schliessKnoepfe = Array.from(feld.querySelectorAll('[data-zbu-picker-close]'));

      this.geschenkModal = findeAusgelagert(this, '[data-zbu-gift-modal]', `.zbu-geschenk-${this.dataset.sectionId}`);

      this.geschenkKacheln = Array.from(this.querySelectorAll('[data-zbu-gift-tier]'));
      this.geschenkKachelHinweise = Array.from(this.querySelectorAll('[data-zbu-gift-hint]'));
      this.geschenkEmojis = Array.from(this.querySelectorAll('[data-zbu-gift-emoji]'));
      this.geschenkHaken = Array.from(this.querySelectorAll('[data-zbu-gift-check]'));

      this.geschenkBox = this.querySelector('[data-zbu-gift-box]');
      this.geschenkMedien = this.querySelector('[data-zbu-gift-media]');
      this.geschenkTitel = this.querySelector('[data-zbu-gift-title]');
      this.geschenkNotiz = this.querySelector('[data-zbu-gift-note]');
      this.geschenkBoxKnopf = this.geschenkBox ? this.geschenkBox.querySelector('[data-zbu-gift-trigger]') : null;
      this.geschenkBoxWeg = this.querySelector('[data-zbu-gift-remove]');

      this.geschenkAusloeser = Array.from(this.querySelectorAll('[data-zbu-gift-trigger]'));

      const geschenkFeld = this.geschenkModal;

      this.geschenkKarten = geschenkFeld ? Array.from(geschenkFeld.querySelectorAll('[data-zbu-gift-card]')) : [];
      this.geschenkLoeschen = geschenkFeld ? geschenkFeld.querySelector('[data-zbu-gift-clear]') : null;
      this.geschenkSchliesser = geschenkFeld
        ? Array.from(geschenkFeld.querySelectorAll('[data-zbu-gift-close]'))
        : [];

      this.geschenkAn = Boolean(this.geschenkModal) && this.geschenkSchwelle > 0;
    }

    findePicker() {
      return findeAusgelagert(this, '[data-zbu-picker]', `.zbu-picker-${this.dataset.sectionId}`);
    }

    verdrahte() {
      if (this.verdrahtet) {
        this.verdrahteGlobal();
        return;
      }

      this.verdrahtet = true;

      if (this.slotsTrack) {
        this.slotsTrack.addEventListener('click', (event) => this.onSlotClick(event));
        this.slotsTrack.addEventListener('change', (event) => this.onSlotChange(event));
        this.slotsTrack.addEventListener('scroll', () => this.aktualisiereDots(), { passive: true });
      }

      if (this.dotsLeiste) {
        this.dotsLeiste.addEventListener('click', (event) => {
          const punkt = event.target.closest('[data-zbu-dot]');

          if (punkt) this.springeZu(Number(punkt.dataset.zbuDot));
        });
      }

      if (this.liste) this.liste.addEventListener('click', (event) => this.onCheckoutClick(event));
      if (this.leerenKnopf) this.leerenKnopf.addEventListener('click', () => this.leere());
      if (this.submit) this.submit.addEventListener('click', () => this.onSubmit());

      this.schliessKnoepfe.forEach((knopf) => {
        knopf.addEventListener('click', () => this.schliessePicker());
      });

      this.geschenkAusloeser.forEach((knopf) => {
        knopf.addEventListener('click', () => this.oeffneGeschenk(knopf));
      });

      this.geschenkSchliesser.forEach((knopf) => {
        knopf.addEventListener('click', () => this.schliesseGeschenk());
      });

      if (this.geschenkBoxWeg) {
        this.geschenkBoxWeg.addEventListener('click', () => this.entferneGeschenk());
      }

      if (this.geschenkModal) {
        this.geschenkModal.addEventListener('click', (event) => {
          const waehlen = event.target.closest('[data-zbu-gift-choose]');

          if (waehlen) {
            this.waehleGeschenk(waehlen);
            return;
          }

          if (event.target.closest('[data-zbu-gift-clear]')) this.entferneGeschenk();
        });

        this.geschenkModal.addEventListener('change', (event) => {
          const auswahl = event.target.closest('[data-zbu-gift-variant]');

          if (auswahl) this.zeichneGeschenkPreis(auswahl);
        });
      }

      if (this.suchfeld) {
        this.suchfeld.addEventListener('input', () => this.plantSuche());
      }

      if (this.trefferListe) {
        this.trefferListe.addEventListener('click', (event) => this.onTrefferClick(event));
      }

      this.kategorieTabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          this.aktiveKategorie = tab.dataset.zbuTab;
          this.zeichneTabs();
          this.suche();
        });
      });

      this.onKeydown = this.onKeydown.bind(this);

      this.onResize = () => {
        window.clearTimeout(this.resizeTimer);
        this.resizeTimer = window.setTimeout(() => this.baueDots(), 150);
      };

      this.verdrahteGlobal();
    }

    verdrahteGlobal() {
      document.addEventListener('keydown', this.onKeydown);
      window.addEventListener('resize', this.onResize);
    }

    stufenLabel(stufe) {
      if (!stufe) return '';

      return stufe.label || (stufe.rabatt > 0 ? `${stufe.rabatt} %` : stufe.zusatz || '');
    }

    wort(anzahl) {
      return Number(anzahl) === 1 ? this.texte.wortEins || '' : this.texte.wortViele || '';
    }

    baueSlots() {
      if (!this.slotsTrack || !this.slotVorlage) return;

      const gebraucht = Math.min(Math.max(this.auswahl.length + 1, START_KARTEN), this.maxProdukte);

      if (this.slotsTrack.childElementCount !== gebraucht) {
        this.slotsTrack.innerHTML = '';

        for (let i = 0; i < gebraucht; i += 1) {
          const knoten = this.slotVorlage.content.firstElementChild.cloneNode(true);

          knoten.dataset.zbuSlot = String(i);
          this.slotsTrack.appendChild(knoten);
        }
      }

      this.slotElemente = Array.from(this.slotsTrack.children);
      this.baueDots();
    }

    slotIndex(element) {
      const slot = element.closest('[data-zbu-slot]');

      return slot ? Number(slot.dataset.zbuSlot) : -1;
    }

    onSlotClick(event) {
      const auswaehlen = event.target.closest('[data-zbu-slot-pick], [data-zbu-slot-swap]');

      if (auswaehlen) {
        this.oeffnePicker(this.slotIndex(auswaehlen));
        return;
      }

      const entfernen = event.target.closest('[data-zbu-slot-remove]');

      if (entfernen) this.entferne(this.slotIndex(entfernen));
    }

    onSlotChange(event) {
      const auswahl = event.target.closest('[data-zbu-slot-variant]');

      if (!auswahl) return;

      const index = this.slotIndex(auswahl);
      const eintrag = index >= 0 ? this.auswahl[index] : null;

      if (!eintrag) return;

      eintrag.variantId = auswahl.value;
      this.zeichne();
    }

    aktiveVariante(eintrag) {
      if (!eintrag || !eintrag.varianten || !eintrag.varianten.length) return null;

      return (
        eintrag.varianten.find((variante) => String(variante.id) === String(eintrag.variantId)) ||
        eintrag.varianten[0]
      );
    }

    entferne(index) {
      if (index < 0 || index >= this.auswahl.length) return;

      this.auswahl.splice(index, 1);
      this.zeichne();
    }

    leere() {
      if (!this.auswahl.length) return;

      this.auswahl = [];
      this.zeichne();
    }

    zeichneSlots() {
      if (!this.slotElemente) return;

      this.slotElemente.forEach((slot, index) => {
        const eintrag = this.auswahl[index] || null;
        const variante = this.aktiveVariante(eintrag);

        const medien = slot.querySelector('[data-zbu-slot-media]');
        const nummer = slot.querySelector('[data-zbu-slot-index]');
        const titel = slot.querySelector('[data-zbu-slot-title]');
        const cta = slot.querySelector('[data-zbu-slot-cta]');
        const knopf = slot.querySelector('[data-zbu-slot-pick]');
        const belegtBereich = slot.querySelector('[data-zbu-slot-filled]');

        const platzTitel = setzeText(this.texte.platzTitel, { nummer: index + 1 });

        if (nummer) nummer.textContent = platzTitel;

        const aktiv = !eintrag && index === this.auswahl.length;

        slot.classList.toggle('is-belegt', Boolean(eintrag));
        slot.classList.toggle('is-aktiv', aktiv);
        slot.classList.toggle('is-wartend', !eintrag && !aktiv);

        if (!eintrag) {
          if (medien) medien.innerHTML = '<span class="zbu-slot__plus" aria-hidden="true">+</span>';
          if (titel) titel.textContent = '';
          if (cta) cta.textContent = this.texte.platzCta || '';

          if (knopf) {
            knopf.disabled = !aktiv;
            knopf.setAttribute('aria-label', `${platzTitel}: ${this.texte.platzCta || ''}`);
          }

          setzeVersteckt(belegtBereich, true);
          return;
        }

        if (knopf) {
          knopf.disabled = false;
          knopf.setAttribute('aria-label', `${platzTitel}: ${this.texte.tauschen || ''}`);
        }

        if (medien) {
          const bild = (variante && variante.bild) || eintrag.bild || '';

          medien.innerHTML = '';

          if (bild) {
            const element = document.createElement('img');

            element.src = bild;
            element.alt = '';
            element.loading = 'lazy';
            medien.appendChild(element);
          }
        }

        if (titel) titel.textContent = eintrag.titel;
        if (cta) cta.textContent = '';

        setzeVersteckt(belegtBereich, false);

        this.zeichneSlotVarianten(slot, eintrag, variante);
        this.zeichneSlotPreis(slot, variante);

        const tauschen = slot.querySelector('[data-zbu-slot-swap]');
        const entfernen = slot.querySelector('[data-zbu-slot-remove]');

        if (tauschen) tauschen.textContent = this.texte.tauschen || '';
        if (entfernen) entfernen.textContent = this.texte.entfernen || '';
      });
    }

    zeichneSlotVarianten(slot, eintrag, variante) {
      const auswahl = slot.querySelector('[data-zbu-slot-variant]');

      if (!auswahl) return;

      const mehrere = eintrag.varianten && eintrag.varianten.length > 1;

      setzeVersteckt(auswahl, !mehrere);

      if (!mehrere) {
        auswahl.innerHTML = '';
        auswahl.dataset.fuer = '';
        return;
      }

      const gewuenscht = variante ? String(variante.id) : '';

      if (auswahl.dataset.fuer !== String(eintrag.handle)) {
        auswahl.innerHTML = '';
        auswahl.dataset.fuer = String(eintrag.handle);

        eintrag.varianten.forEach((eine) => {
          const option = document.createElement('option');

          option.value = String(eine.id);
          option.textContent = eine.titel;
          auswahl.appendChild(option);
        });
      }

      auswahl.value = gewuenscht;
      auswahl.setAttribute('aria-label', `Variante: ${eintrag.titel}`);
    }

    zeichneSlotPreis(slot, variante) {
      const preisFeld = slot.querySelector('[data-zbu-slot-price]');
      const vergleichFeld = slot.querySelector('[data-zbu-slot-compare]');
      const einheitFeld = slot.querySelector('[data-zbu-slot-unit]');

      if (preisFeld) {
        preisFeld.textContent = variante ? formatiereGeld(variante.preis, this.geldFormat) : '';
      }

      if (vergleichFeld) {
        const zeigen = Boolean(variante) && variante.vergleich > variante.preis;

        vergleichFeld.textContent = zeigen ? formatiereGeld(variante.vergleich, this.geldFormat) : '';
        setzeVersteckt(vergleichFeld, !zeigen);
      }

      if (einheitFeld) {
        const einheit = variante ? variante.einheit : '';

        einheitFeld.textContent = einheit || '';
        setzeVersteckt(einheitFeld, !einheit);
      }
    }

    schrittweite() {
      if (!this.slotsTrack) return 0;

      const erster = this.slotsTrack.firstElementChild;

      if (!erster) return this.slotsTrack.clientWidth;

      const abstand = parseFloat(getComputedStyle(this.slotsTrack).columnGap) || 0;

      return erster.getBoundingClientRect().width + abstand;
    }

    baueDots() {
      if (!this.dotsLeiste || !this.slotsTrack) return;

      const karten = this.slotElemente || [];
      const stil = getComputedStyle(this.slotsTrack);
      const abstand = parseFloat(stil.columnGap) || 0;
      const innen =
        this.slotsTrack.clientWidth -
        (parseFloat(stil.paddingLeft) || 0) -
        (parseFloat(stil.paddingRight) || 0);
      const schritt = this.schrittweite();
      const scrollbar = this.slotsTrack.scrollWidth - this.slotsTrack.clientWidth > 4;

      const sichtbar = schritt > 0 ? Math.max(1, Math.floor((innen + abstand) / schritt + 0.02)) : karten.length;
      const anzahl = scrollbar ? Math.max(0, karten.length - sichtbar + 1) : 0;

      setzeVersteckt(this.dotsLeiste, anzahl < 2);

      if (anzahl < 2) {
        this.dotsLeiste.innerHTML = '';
        return;
      }

      if (this.dotsLeiste.childElementCount !== anzahl) {
        this.dotsLeiste.innerHTML = '';

        for (let i = 0; i < anzahl; i += 1) {
          const punkt = document.createElement('button');

          punkt.type = 'button';
          punkt.className = 'zbu__dot';
          punkt.dataset.zbuDot = String(i);
          punkt.setAttribute('aria-label', `Zu Produkt ${i + 1} blättern`);
          this.dotsLeiste.appendChild(punkt);
        }
      }

      this.aktualisiereDots();
    }

    aktualisiereDots() {
      if (!this.dotsLeiste || !this.slotsTrack) return;

      const punkte = Array.from(this.dotsLeiste.children);
      const schritt = this.schrittweite();

      if (!punkte.length || schritt <= 0) return;

      const ende = this.slotsTrack.scrollWidth - this.slotsTrack.clientWidth - 4;
      const index = this.slotsTrack.scrollLeft >= ende
        ? punkte.length - 1
        : Math.min(Math.round(this.slotsTrack.scrollLeft / schritt), punkte.length - 1);

      punkte.forEach((punkt, i) => {
        punkt.classList.toggle('is-aktiv', i === index);
        punkt.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    springeZu(index) {
      if (!this.slotsTrack || !Number.isFinite(index)) return;

      this.slotsTrack.scrollTo({ left: index * this.schrittweite(), behavior: 'smooth' });
    }

    zeigePlatz(index) {
      if (!this.slotElemente || !this.slotElemente[index] || !this.slotsTrack) return;

      const slot = this.slotElemente[index];
      const links = slot.offsetLeft - this.slotsTrack.offsetLeft;
      const rechts = links + slot.offsetWidth;
      const sichtbar = this.slotsTrack.scrollLeft;
      const rand = sichtbar + this.slotsTrack.clientWidth;

      if (links >= sichtbar && rechts <= rand) return;

      this.slotsTrack.scrollTo({ left: Math.max(0, links), behavior: 'smooth' });
    }

    oeffnePicker(index) {
      if (index < 0 || index > this.auswahl.length || index >= this.maxProdukte || !this.picker) return;

      this.offenerPlatz = index;
      this.wahlMarke += 1;

      if (this.pickerTitel) {
        this.pickerTitel.textContent = setzeText(this.texte.sucheTitel, { nummer: index + 1 });
      }

      window.clearTimeout(this.pickerTimer);
      setzeVersteckt(this.picker, false);
      void this.picker.offsetWidth;
      this.picker.classList.add('zbu-picker--offen');
      document.body.classList.add('zbu-picker-offen');

      if (this.suchfeld) {
        this.suchfeld.value = '';
        window.requestAnimationFrame(() => this.suchfeld.focus());
      }

      this.zeichneTabs();
      this.suche();
    }

    schliessePicker() {
      if (!this.picker) return;

      this.picker.classList.remove('zbu-picker--offen');
      loeseSperre();

      window.clearTimeout(this.pickerTimer);
      this.pickerTimer = window.setTimeout(() => setzeVersteckt(this.picker, true), 250);

      const index = this.offenerPlatz;

      this.offenerPlatz = -1;
      this.wahlMarke += 1;

      if (index >= 0 && this.slotElemente && this.slotElemente[index]) {
        const knopf = this.slotElemente[index].querySelector('[data-zbu-slot-pick]');

        if (knopf) knopf.focus();
      }
    }

    onKeydown(event) {
      if (event.key === 'Tab') {
        this.haltFokus(event);
        return;
      }

      if (event.key !== 'Escape') return;

      if (this.geschenkOffen) {
        this.schliesseGeschenk();
        return;
      }

      if (this.offenerPlatz < 0) return;

      this.schliessePicker();
    }

    offenerDialog() {
      if (this.geschenkOffen && this.geschenkModal) return this.geschenkModal;
      if (this.offenerPlatz >= 0 && this.picker) return this.picker;

      return null;
    }

    haltFokus(event) {
      const huelle = this.offenerDialog();

      if (!huelle) return;

      const dialog = huelle.querySelector('.zbu-picker__dialog') || huelle;
      const ziele = fokussierbare(dialog);

      if (!ziele.length) return;

      const erster = ziele[0];
      const letzter = ziele[ziele.length - 1];
      const aktiv = document.activeElement;

      if (!dialog.contains(aktiv)) {
        event.preventDefault();
        (event.shiftKey ? letzter : erster).focus();
        return;
      }

      if (event.shiftKey && aktiv === erster) {
        event.preventDefault();
        letzter.focus();
        return;
      }

      if (!event.shiftKey && aktiv === letzter) {
        event.preventDefault();
        erster.focus();
      }
    }

    geschenkFrei(stand) {
      if (!this.geschenkAn) return false;

      const anzahl = stand ? stand.anzahl : this.auswahl.length;

      return anzahl >= this.geschenkSchwelle;
    }

    oeffneGeschenk(knopf) {
      if (!this.geschenkModal || !this.geschenkFrei()) return;

      this.geschenkFokus = knopf || null;
      this.geschenkOffen = true;

      window.clearTimeout(this.geschenkTimer);
      setzeVersteckt(this.geschenkModal, false);
      void this.geschenkModal.offsetWidth;
      this.geschenkModal.classList.add('zbu-picker--offen');
      document.body.classList.add('zbu-picker-offen');

      window.requestAnimationFrame(() => {
        const dialog = this.geschenkModal.querySelector('.zbu-picker__dialog') || this.geschenkModal;
        const gewaehlt = dialog.querySelector('.is-gewaehlt [data-zbu-gift-choose]');
        const ziel = gewaehlt || fokussierbare(dialog)[0];

        if (ziel) ziel.focus();
      });
    }

    schliesseGeschenk() {
      if (!this.geschenkModal) return;

      this.geschenkOffen = false;
      this.geschenkModal.classList.remove('zbu-picker--offen');

      loeseSperre();

      window.clearTimeout(this.geschenkTimer);
      this.geschenkTimer = window.setTimeout(() => setzeVersteckt(this.geschenkModal, true), 250);

      const ziel = this.geschenkFokus;

      this.geschenkFokus = null;

      if (ziel && ziel.isConnected && !ziel.disabled) ziel.focus();
    }

    waehleGeschenk(knopf) {
      const karte = knopf.closest('[data-zbu-gift-card]');

      if (!karte || !this.geschenkFrei()) return;

      const auswahl = karte.querySelector('[data-zbu-gift-variant]');
      const variantId = auswahl ? auswahl.value : knopf.dataset.variantId;

      if (!variantId) return;

      const gewaehlteOption = auswahl ? auswahl.options[auswahl.selectedIndex] : null;

      this.geschenkWahl = {
        produktId: karte.dataset.productId,
        variantId: String(variantId),
        titel: karte.dataset.titel || '',
        bild: karte.dataset.bild || '',
        variante: gewaehlteOption ? gewaehlteOption.textContent.trim() : '',
      };

      this.schliesseGeschenk();
      this.zeichne();
    }

    entferneGeschenk() {
      if (!this.geschenkWahl) return;

      this.geschenkWahl = null;

      if (this.geschenkOffen) this.schliesseGeschenk();

      this.zeichne();
    }

    zeichneGeschenkPreis(auswahl) {
      const karte = auswahl.closest('[data-zbu-gift-card]');
      const feld = karte ? karte.querySelector('[data-zbu-gift-price]') : null;
      const option = auswahl.options[auswahl.selectedIndex];

      if (!feld || !option) return;

      feld.textContent = formatiereGeld(Number(option.dataset.preis) || 0, this.geldFormat);
    }

    zeichneTabs() {
      this.kategorieTabs.forEach((tab) => {
        tab.setAttribute('aria-pressed', tab.dataset.zbuTab === this.aktiveKategorie ? 'true' : 'false');
      });

      const getippt = this.suchfeld ? this.suchfeld.value.trim().length > 0 : false;

      if (this.tabsLeiste) setzeVersteckt(this.tabsLeiste, getippt);
    }

    plantSuche() {
      window.clearTimeout(this.suchTimer);
      this.suchTimer = window.setTimeout(() => this.suche(), SUCH_VERZOEGERUNG);
    }

    async suche() {
      const begriff = this.suchfeld ? this.suchfeld.value.trim() : '';

      this.zeichneTabs();

      if (!begriff) {
        this.zeichneTreffer(this.suchePool(''));
        return;
      }

      this.zeigeHinweis(this.texte.sucheLaedt);

      try {
        const treffer = await this.frageShop(begriff);

        if (this.suchfeld && this.suchfeld.value.trim() !== begriff) return;

        this.zeichneTreffer(treffer);
      } catch (fehler) {
        if (fehler.name === 'AbortError') return;

        this.zeichneTreffer(this.suchePool(begriff));
      }
    }

    suchePool(begriff) {
      const gesucht = normalisiere(begriff);
      const quelle =
        this.kategorien.find((kategorie) => kategorie.id === this.aktiveKategorie) || this.kategorien[0];

      let produkte = [];

      if (gesucht) {
        this.kategorien.forEach((kategorie) => {
          produkte = produkte.concat(kategorie.produkte || []);
        });
      } else {
        produkte = (quelle && quelle.produkte) || [];
      }

      const gesehen = new Set();

      return produkte
        .filter((produkt) => {
          if (gesehen.has(produkt.handle)) return false;
          gesehen.add(produkt.handle);

          return !gesucht || normalisiere(produkt.titel).indexOf(gesucht) !== -1;
        })
        .map((produkt) => ({
          handle: produkt.handle,
          titel: produkt.titel,
          bild: produkt.bild,
          preis: produkt.preis,
        }));
    }

    async frageShop(begriff) {
      if (this.laufendeSuche) this.laufendeSuche.abort();

      this.laufendeSuche = new AbortController();

      const adresse =
        `${sucheRoute()}.json?q=${encodeURIComponent(begriff)}` +
        `&resources[type]=product&resources[limit]=${TREFFER_ANZAHL}` +
        '&resources[options][unavailable_products]=hide' +
        `&resources[options][fields]=${SUCH_FELDER}`;

      const antwort = await fetch(adresse, { signal: this.laufendeSuche.signal });

      if (!antwort.ok) throw new Error(`Suche fehlgeschlagen (${antwort.status})`);

      const daten = await antwort.json();
      const produkte =
        (daten.resources && daten.resources.results && daten.resources.results.products) || [];

      return produkte
        .filter((produkt) => produkt.available !== false)
        .map((produkt) => ({
          handle: produkt.handle,
          titel: produkt.title,
          bild: bildGroesse(
            produkt.featured_image ? produkt.featured_image.url || produkt.image : produkt.image,
            BILD_TREFFER
          ),
          preis: zuCent(produkt.price),
        }));
    }

    zeichneTreffer(liste) {
      if (!this.trefferListe || !this.trefferVorlage) return;

      this.trefferListe.innerHTML = '';

      if (!liste.length) {
        const getippt = this.suchfeld ? this.suchfeld.value.trim().length > 0 : false;

        this.zeigeHinweis(getippt ? this.texte.sucheLeer : this.texte.sucheStart);
        return;
      }

      this.zeigeHinweis('');

      liste.forEach((produkt) => {
        const knoten = this.trefferVorlage.content.firstElementChild.cloneNode(true);
        const knopf = knoten.querySelector('[data-zbu-result]');
        const bild = knoten.querySelector('[data-zbu-result-image]');
        const titel = knoten.querySelector('[data-zbu-result-title]');
        const preis = knoten.querySelector('[data-zbu-result-price]');

        if (knopf) knopf.dataset.handle = produkt.handle;

        if (bild) {
          if (produkt.bild) bild.src = produkt.bild;
          else bild.remove();
        }

        if (titel) titel.textContent = produkt.titel;
        if (preis) preis.textContent = formatiereGeld(produkt.preis, this.geldFormat);

        this.trefferListe.appendChild(knoten);
      });
    }

    zeigeHinweis(text) {
      if (!this.pickerHinweis) return;

      this.pickerHinweis.textContent = text || '';
      setzeVersteckt(this.pickerHinweis, !text);
    }

    async onTrefferClick(event) {
      const knopf = event.target.closest('[data-zbu-result]');

      if (!knopf || knopf.disabled || this.offenerPlatz < 0) return;

      const index = this.offenerPlatz;
      const marke = this.wahlMarke;

      knopf.disabled = true;
      knopf.classList.add('is-laedt');

      let produkt = null;

      try {
        produkt = await this.ladeProdukt(knopf.dataset.handle);
      } finally {
        if (knopf.isConnected) {
          knopf.disabled = false;
          knopf.classList.remove('is-laedt');
        }
      }

      if (this.wahlMarke !== marke || this.offenerPlatz !== index) return;

      const varianten = nurLieferbar(produkt && produkt.varianten);

      if (!produkt) {
        this.zeigeHinweis(this.texte.fehler);
        return;
      }

      if (!varianten.length) {
        knopf.disabled = true;
        knopf.classList.add('is-ausverkauft');
        this.zeigeHinweis(this.texte.ausverkauft || this.texte.fehler);
        return;
      }

      const eintrag = {
        handle: produkt.handle,
        produktId: produkt.id,
        titel: produkt.titel,
        url: produkt.url,
        bild: produkt.bild,
        varianten: varianten,
        variantId: varianten[0].id,
      };

      if (index >= this.auswahl.length) this.auswahl.push(eintrag);
      else this.auswahl[index] = eintrag;

      this.zeichne();
      this.schliessePicker();

      const naechster = this.auswahl.length;

      if (naechster < this.maxProdukte) {
        this.zeigePlatz(naechster);

        if (this.config.autoWeiter) {
          window.setTimeout(() => this.oeffnePicker(naechster), 180);
        }
      }
    }

    async ladeProdukt(handle) {
      if (!handle) return null;

      const gemerkt = this.produktCache.get(handle) || null;

      if (gemerkt && gemerkt.geprueft) return gemerkt;

      try {
        const antwort = await fetch(`${ROOT_URL}products/${handle}.js`);

        if (!antwort.ok) return gemerkt;

        const roh = await antwort.json();
        const produkt = {
          id: roh.id,
          handle: roh.handle,
          titel: roh.title,
          url: roh.url || `${ROOT_URL}products/${roh.handle}`,
          bild: bildGroesse(roh.featured_image, BILD_KARTE),
          preis: roh.price,
          geprueft: true,
          varianten: (roh.variants || [])
            .filter((variante) => variante.available)
            .map((variante) => ({
              id: variante.id,
              titel: variante.title,
              preis: variante.price,
              vergleich: variante.compare_at_price || 0,
              verfuegbar: true,
              bild: bildGroesse(
                (variante.featured_image && variante.featured_image.src) || roh.featured_image,
                BILD_KARTE
              ),
              einheit: baueEinheit(variante, this.geldFormat),
            })),
        };

        this.produktCache.set(handle, produkt);

        return produkt;
      } catch (fehler) {
        return gemerkt;
      }
    }

    rechne() {
      const anzahl = this.auswahl.length;

      let summe = 0;
      let guenstigster = null;

      this.auswahl.forEach((eintrag) => {
        const variante = this.aktiveVariante(eintrag);

        if (!variante) return;

        summe += variante.preis;

        if (guenstigster === null || variante.preis < guenstigster) guenstigster = variante.preis;
      });

      let erreicht = null;

      this.stufen.forEach((stufe) => {
        if (anzahl >= stufe.schwelle) erreicht = stufe;
      });

      const naechste = this.stufen.find((stufe) => stufe.schwelle > anzahl) || null;
      const erste = this.stufen.length ? this.stufen[0] : null;

      const basis = erreicht ? erreicht.schwelle : 0;
      const ziel = naechste ? naechste.schwelle : basis;
      const spanne = ziel - basis;

      const anteil = naechste ? (spanne > 0 ? ((anzahl - basis) / spanne) * 100 : 0) : 100;

      const prozent = erreicht ? Number(erreicht.rabatt) || 0 : 0;
      const basispreis = guenstigster === null ? 0 : guenstigster;
      const rabatt = Math.round((basispreis * prozent) / 100);

      return {
        anzahl,
        summe,
        erreicht,
        naechste,
        erste,
        ziel,
        anteil,
        prozent,
        rabatt,
        gesamt: summe - rabatt,
        geschenk: this.geschenkSchwelle > 0 && anzahl >= this.geschenkSchwelle,
        fehlt: naechste ? naechste.schwelle - anzahl : 0,
        voll: anzahl >= this.maxProdukte,
      };
    }

    zeichne() {
      const stand = this.rechne();

      this.baueSlots();
      this.zeichneSlots();
      this.zeichneStufen(stand);
      this.zeichneGeschenk(stand);
      this.zeichneFortschritt(stand);
      this.zeichneCheckout(stand);
    }

    zeichneGeschenk(stand) {
      if (!this.geschenkAn) return;

      const frei = this.geschenkFrei(stand);

      if (!frei && this.geschenkWahl) this.geschenkWahl = null;
      if (!frei && this.geschenkOffen) this.schliesseGeschenk();

      const wahl = this.geschenkWahl;
      const gewaehlt = Boolean(wahl);

      this.geschenkKacheln.forEach((kachel) => {
        kachel.classList.toggle('is-ruft', frei && !gewaehlt);
        kachel.classList.toggle('is-gewaehlt', gewaehlt);
      });

      this.geschenkKachelHinweise.forEach((hinweis) => setzeVersteckt(hinweis, !frei));
      this.geschenkEmojis.forEach((emoji) => setzeVersteckt(emoji, gewaehlt));
      this.geschenkHaken.forEach((haken) => setzeVersteckt(haken, !gewaehlt));

      this.geschenkAusloeser.forEach((knopf) => {
        knopf.disabled = !frei;
      });

      setzeVersteckt(this.geschenkBox, !frei);

      if (this.geschenkBox) this.geschenkBox.classList.toggle('is-gewaehlt', gewaehlt);

      if (this.geschenkTitel) {
        this.geschenkTitel.textContent = gewaehlt ? wahl.titel : this.texte.geschenkHinweis || '';
      }

      if (this.geschenkNotiz) {
        const teile = [];

        if (gewaehlt && wahl.variante && wahl.variante !== 'Default Title') teile.push(wahl.variante);
        if (this.texte.geschenkBadge) teile.push(this.texte.geschenkBadge);

        this.geschenkNotiz.textContent = teile.join(' · ');
      }

      if (this.geschenkMedien) {
        const bild = gewaehlt ? wahl.bild : '';

        this.geschenkMedien.innerHTML = '';

        if (bild) {
          const element = document.createElement('img');

          element.src = bild;
          element.alt = '';
          element.loading = 'lazy';
          this.geschenkMedien.appendChild(element);
        } else {
          const zeichen = document.createElement('span');

          zeichen.className = 'zbu__geschenk-emoji';
          zeichen.setAttribute('aria-hidden', 'true');
          zeichen.textContent = '🎁';
          this.geschenkMedien.appendChild(zeichen);
        }
      }

      if (this.geschenkBoxKnopf) {
        this.geschenkBoxKnopf.textContent = gewaehlt
          ? this.texte.tauschen || ''
          : this.texte.geschenkCta || '';
      }

      setzeVersteckt(this.geschenkBoxWeg, !gewaehlt);
      setzeVersteckt(this.geschenkLoeschen, !gewaehlt);

      this.geschenkKarten.forEach((karte) => {
        const dieses = gewaehlt && String(karte.dataset.productId) === String(wahl.produktId);

        karte.classList.toggle('is-gewaehlt', dieses);
      });
    }

    stufeErreichtText(rabatt) {
      const vorlage = String(this.texte.stufeErreicht || '');

      if (rabatt > 0) return setzeText(vorlage, { prozent: rabatt });

      const rest = vorlage
        .replace(/\[prozent\]\s*%?/gi, '')
        .replace(/\s{2,}/g, ' ')
        .trim();

      return rest.charAt(0).toUpperCase() + rest.slice(1);
    }

    zeichneStufen(stand) {
      this.stufenKacheln.forEach((kachel) => {
        const schwelle = Number(kachel.dataset.schwelle) || 0;
        const rabatt = Number(kachel.dataset.rabatt) || 0;
        const erreicht = schwelle > 0 && stand.anzahl >= schwelle;
        const ziel = Boolean(stand.naechste) && stand.naechste.schwelle === schwelle;

        kachel.classList.toggle('is-erreicht', erreicht);
        kachel.classList.toggle('is-naechste', ziel);

        const marke = kachel.querySelector('[data-zbu-stufe-state]');

        if (marke) marke.textContent = erreicht ? this.stufeErreichtText(rabatt) : '';
      });
    }

    zeichneFortschritt(stand) {
      if (this.balken) this.balken.style.width = `${stand.anteil}%`;

      if (this.meldung) {
        if (stand.anzahl === 0 && stand.erste) {
          this.meldung.textContent = setzeText(this.texte.start, {
            anzahl: stand.erste.schwelle,
            produkt: this.wort(stand.erste.schwelle),
          });
        } else if (stand.naechste) {
          this.meldung.textContent = setzeText(this.texte.fehlt, {
            anzahl: stand.fehlt,
            produkt: this.wort(stand.fehlt),
            rabatt: this.stufenLabel(stand.naechste),
          });
        } else {
          this.meldung.textContent = setzeText(this.texte.erreicht, {
            rabatt: this.stufenLabel(stand.erreicht),
          });
        }
      }
    }

    rabattLabelText(prozent) {
      const vorlage = String(this.texte.rabattZeile || '').trim();
      const zahl = String(Number(prozent) || 0);

      if (RABATT_PLATZHALTER.test(vorlage)) return setzeText(vorlage, { prozent: zahl, rabatt: zahl });

      return `${vorlage} (${zahl} %)`.trim();
    }

    zeichneCheckout(stand) {
      if (this.liste) {
        this.liste.innerHTML = '';

        this.auswahl.forEach((eintrag, index) => {
          this.liste.appendChild(this.baueZeile(index, eintrag));
        });
      }

      if (this.leerText) {
        const schwelle = stand.erste ? stand.erste.schwelle : 0;

        this.leerText.textContent = setzeText(this.texte.leereAuswahl, {
          anzahl: schwelle,
          produkt: this.wort(schwelle),
        });

        setzeVersteckt(this.leerText, stand.anzahl > 0);
      }

      if (this.leerenKnopf) setzeVersteckt(this.leerenKnopf, stand.anzahl === 0);

      const mitRabatt = stand.rabatt > 0;

      setzeVersteckt(this.zwischenZeile, !mitRabatt);
      setzeVersteckt(this.rabattZeile, !mitRabatt);

      if (this.checkout) this.checkout.classList.toggle('zbu__checkout--knapp', !mitRabatt);

      if (this.zwischenFeld) this.zwischenFeld.textContent = formatiereGeld(stand.summe, this.geldFormat);

      if (this.rabattLabel) {
        this.rabattLabel.textContent = this.rabattLabelText(stand.prozent);
      }

      if (this.rabattFeld) {
        this.rabattFeld.textContent = `-${formatiereGeld(stand.rabatt, this.geldFormat)}`;
      }

      if (this.summeFeld) this.summeFeld.textContent = formatiereGeld(stand.gesamt, this.geldFormat);

      this.zeichneSparhinweis(stand);

      const unterStufe = Boolean(this.config.nurAbStufe) && !stand.erreicht;
      const gesperrt = stand.anzahl === 0 || unterStufe;

      if (this.submit) this.submit.disabled = Boolean(this.laedt) || gesperrt;

      if (this.submitText && !this.laedt) {
        if (stand.anzahl === 0) {
          this.submitText.textContent = this.texte.buttonLeer || '';
        } else if (unterStufe) {
          this.submitText.textContent = setzeText(this.texte.buttonStufe, {
            anzahl: stand.fehlt,
            produkt: this.wort(stand.fehlt),
          });
        } else {
          this.submitText.textContent = setzeText(this.texte.button, {
            anzahl: stand.anzahl,
            produkt: this.wort(stand.anzahl),
            betrag: formatiereGeld(stand.gesamt, this.geldFormat),
          });
        }
      }
    }

    zeichneSparhinweis(stand) {
      if (!this.sparFeld) return;

      const betrag = formatiereGeld(stand.rabatt, this.geldFormat);

      let text = '';

      if (stand.rabatt > 0 && stand.geschenk) text = setzeText(this.texte.sparenGeschenk, { betrag });
      else if (stand.rabatt > 0) text = setzeText(this.texte.sparen, { betrag });
      else if (stand.geschenk) text = this.texte.geschenk || '';

      this.sparFeld.textContent = text;
      setzeVersteckt(this.sparFeld, !text);
    }

    baueZeile(index, eintrag) {
      const variante = this.aktiveVariante(eintrag);
      const preis = variante ? variante.preis : 0;
      const zeile = document.createElement('li');

      zeile.className = 'zbu-line';

      const medien = document.createElement('div');

      medien.className = 'zbu-line__media';

      const bild = (variante && variante.bild) || eintrag.bild || '';

      if (bild) {
        const element = document.createElement('img');

        element.src = bild;
        element.alt = '';
        element.loading = 'lazy';
        medien.appendChild(element);
      } else {
        const nummer = document.createElement('span');

        nummer.className = 'zbu-line__num';
        nummer.textContent = String(index + 1).padStart(2, '0');
        medien.appendChild(nummer);
      }

      const text = document.createElement('div');

      text.className = 'zbu-line__body';

      const titel = document.createElement('p');

      titel.className = 'zbu-line__title';
      titel.textContent = eintrag.titel;

      const variantenText = variante && variante.titel !== 'Default Title' ? variante.titel : '';

      text.appendChild(titel);

      if (variantenText) {
        const meta = document.createElement('p');

        meta.className = 'zbu-line__meta';
        meta.textContent = variantenText;
        text.appendChild(meta);
      }

      const preisFeld = document.createElement('span');

      preisFeld.className = 'zbu-line__price';
      preisFeld.textContent = formatiereGeld(preis, this.geldFormat);

      const entfernen = document.createElement('button');

      entfernen.type = 'button';
      entfernen.className = 'zbu-line__remove';
      entfernen.dataset.zbuRemove = String(index);
      entfernen.setAttribute('aria-label', `${eintrag.titel} entfernen`);
      entfernen.innerHTML =
        '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';

      zeile.appendChild(medien);
      zeile.appendChild(text);
      zeile.appendChild(preisFeld);
      zeile.appendChild(entfernen);

      return zeile;
    }

    onCheckoutClick(event) {
      const knopf = event.target.closest('[data-zbu-remove]');

      if (!knopf) return;

      this.entferne(Number(knopf.dataset.zbuRemove));
    }

    ziehlWarenkorb() {
      return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }

    async onSubmit() {
      const stand = this.rechne();

      if (this.laedt || stand.anzahl === 0) return;
      if (this.config.nurAbStufe && !stand.erreicht) return;

      const mengen = new Map();

      this.auswahl.forEach((eintrag) => {
        const variante = this.aktiveVariante(eintrag);

        if (!variante) return;

        mengen.set(variante.id, (mengen.get(variante.id) || 0) + 1);
      });

      const artikel = Array.from(mengen, ([id, menge]) => ({ id: Number(id), quantity: menge }));

      if (this.geschenkWahl && this.geschenkFrei(stand)) {
        artikel.push({
          id: Number(this.geschenkWahl.variantId),
          quantity: 1,
          properties: { [GESCHENK_EIGENSCHAFT]: String(this.geschenkSchwelle) },
        });
      }

      this.setzeLadezustand(true);
      setzeVersteckt(this.fehlerFeld, true);

      const warenkorb = this.ziehlWarenkorb();
      const nutzlast = { items: artikel };

      if (warenkorb && typeof warenkorb.getSectionsToRender === 'function') {
        nutzlast.sections = warenkorb.getSectionsToRender().map((abschnitt) => abschnitt.id);
        nutzlast.sections_url = window.location.pathname;
      }

      try {
        const antwort = await fetch(`${ROOT_URL}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(nutzlast),
        });

        const daten = await antwort.json();

        if (!antwort.ok) {
          this.zeigeFehler(daten.description || daten.message || '');
          return;
        }

        this.auswahl = [];
        this.geschenkWahl = null;
        this.zeichne();

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, cartData: daten });
        }

        if (warenkorb && typeof warenkorb.renderContents === 'function') {
          const ersterArtikel = (daten.items && daten.items[0]) || {};
          const innen = warenkorb.querySelector('.drawer__inner');

          warenkorb.classList.remove('is-empty');

          if (innen) innen.classList.remove('is-empty');

          warenkorb.renderContents(
            Object.assign({}, daten, { key: ersterArtikel.key, id: ersterArtikel.product_id })
          );
        } else {
          window.location = `${ROOT_URL}cart`;
        }
      } catch (fehler) {
        this.zeigeFehler('');
      } finally {
        this.setzeLadezustand(false);
        this.zeichne();
      }
    }

    setzeLadezustand(zustand) {
      this.laedt = zustand;

      if (!this.submit) return;

      this.submit.disabled = zustand;

      if (this.submitText && zustand) {
        this.submitText.textContent = this.texte.laedt || '…';
      }
    }

    zeigeFehler(meldung) {
      if (!this.fehlerFeld) return;

      this.fehlerFeld.textContent = meldung || this.texte.fehler || '';
      setzeVersteckt(this.fehlerFeld, false);
    }
  }

  customElements.define('zoorian-bundle', ZoorianBundle);
})();
